import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  height: ", ";\n  overflow: hidden;\n  position: relative;\n  transition: ", ";\n  visibility: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { property } from '@scp/ui-shared/theme/variables';

function getTransition(collapsed) {
  var visibilityTransition = collapsed ? ", visibility 0ms linear ".concat(property.transitionDuration, "ms") : ", visibility 0ms linear 0ms";
  return "height ".concat(property.transition) + visibilityTransition;
}

var Collapse = styled.div(_templateObject(), function (props) {
  return props.collapsed ? 0 : "".concat(props.heightValue, "px");
}, function (props) {
  return getTransition(props.collapsed);
}, function (props) {
  return props.collapsed ? 'hidden' : 'visible';
});
/**
 * A Wrapper component that makes it's children a controlled colapsible element
 *
 * @example ./__docs__/CollapsibleWrapper.md
 */

export function CollapsibleWrapper(_ref) {
  var children = _ref.children,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? true : _ref$collapsed;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      collapseHeight = _useState2[0],
      setCollapseHeight = _useState2[1];

  var collapseContent = useRef(null);
  useEffect(function () {
    if (collapseContent.current) setCollapseHeight(collapseContent.current.offsetHeight);
  }, []);
  return React.createElement(Collapse, {
    heightValue: collapseHeight,
    collapsed: collapsed
  }, React.createElement("div", {
    ref: collapseContent
  }, children));
}